import { css, keyframes } from "styled-components";
const rotate = /*#__PURE__*/keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
const rotateAnimation = /*#__PURE__*/css(["animation:", " 1s linear infinite;"], rotate);
export default rotateAnimation;
//# sourceMappingURL=rotate.js.map